export const PARKINID = "PARKINID";
export const PARKINGADDRESS = "PARKINGADDRESS";
export const PARKINGTIME = "PARKINGTIME";
export const PARKINGINDEX = "PARKINGINDEX";
export const PARKINGLATLONG = "PARKINGLATLONG";
export const CLEAR_PARKING_DETAILS = "CLEAR_PARKING_DETAILS";


